import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, find, map, filter, reject } from 'lodash';
import classnames from 'classnames';
import { Button } from '@src/components/Button';
import { TextField } from '@src/components/TextField';
import apolloClient from '@src/graphql/apollo';
import { SaveLinkForCompanyProfileDocument } from '@src/graphql/generated';
import { isValidUrl } from '@src/util/url';
import { backgroundGradient } from './styles.scss';

export default class Media extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    defaultValues: PropTypes.arrayOf(PropTypes.object),
    onChange: PropTypes.func.isRequired,
  };

  state = {
    hasError: false,
    inputValue: '',
    items: this.props.defaultValues || [],
  };

  addItem = evt => {
    evt.preventDefault();

    if (!isValidUrl(this.state.inputValue)) {
      this.setState({ hasError: true });

      return;
    }

    this.setState(
      ({ items, inputValue }) => {
        const exists = find(items, { url: inputValue });

        if (exists) {
          return { inputValue: '', items };
        }

        return {
          inputValue: '',
          items: [...items, { parsing: true, url: inputValue }],
        };
      },
      async () => {
        const parsing = filter(this.state.items, 'parsing');
        try {
          if (!isEmpty(parsing)) {
            const {
              data: { saveLink },
            } = await apolloClient.mutate({
              mutation: SaveLinkForCompanyProfileDocument,
              variables: { url: map(parsing, 'url')[0] },
            });

            this.setState(({ items }) => {
              return {
                hasError: false,
                items: [...filter(items, 'id'), saveLink],
              };
            }, this.itemsChanged);
          }
        } catch (error) {
          this.setState(({ items }) => {
            return {
              hasError: true,
              items: [...filter(items, item => !item.parsing)],
            };
          });
        }
      },
    );
  };

  inputChange = inputValue => this.setState({ inputValue });

  itemsChanged = () => this.props.onChange(this.state.items);

  removeItem = item => {
    this.setState(({ items }) => {
      return { items: reject(items, _item => _item === item) };
    }, this.itemsChanged);
  };

  render() {
    const { className } = this.props;
    const { items, inputValue, hasError } = this.state;

    return (
      <div className={classnames('media', className)}>
        <div className="media-article-list">
          {items
            .filter(item => !item.parsing && !item.error)
            .map((article, i) => (
              <a
                className="media-article"
                href={article.url}
                key={i}
                style={{ backgroundImage: `${backgroundGradient}, url('${(article.image || {}).url}')` }}
                target="_blank"
              >
                <div className="media-article-important">{article.title}</div>
                <div className="media-article-aside">{article.siteName}</div>
                <span
                  className="ui-icon-dismiss-slim"
                  onClick={evt => {
                    evt.stopPropagation();
                    evt.preventDefault();

                    this.removeItem(article);
                  }}
                />
              </a>
            ))}
        </div>

        {hasError && <div className="media-article-error">Unable to parse link</div>}

        <form onSubmit={this.addItem}>
          <TextField
            additionalElements={
              <Button className="media-list-add" isDisabled={!inputValue} type="submit">
                Add
              </Button>
            }
            defaultValue={inputValue}
            label="URL"
            onChange={this.inputChange}
          />
        </form>
      </div>
    );
  }
}
